export enum ProductsType {
  GiftCard = 'GiftCardProduct',
  SimpleProduct = 'SimpleProduct',
  VirtualProduct = 'VirtualProduct',
}
